import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

const Container = styled.div`
  padding: ${tokens.spacer.x2};
  position: relative;
`;

interface FilterDropdownBodyProps {
  children: React.ReactNode;
}

export function GenericFilterBody(props: FilterDropdownBodyProps): JSX.Element {
  const { children } = props;
  return <Container>{children}</Container>;
}
